'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# MyEventsSVG
An SVG My Events icon
 */
var MyEventsSVG = function MyEventsSVG(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? undefined : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width;
  return _react2.default.createElement(
    'svg',
    {
      'aria-label': 'My Events',
      role: 'img',
      height: height || undefined,
      width: width || undefined,
      viewBox: '0 0 200 205',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    _react2.default.createElement(
      'g',
      {
        id: 'myevents',
        fill: color,
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', { d: 'M178.17,44.54v140a19.09,19.09,0,0,1-19.09,19.08h-140A19.09,19.09,0,0,1,0,184.54v-140A19.09,19.09,0,0,1,19.09,25.45H38.18V4.77A4.78,4.78,0,0,1,43,0H58.86a4.77,4.77,0,0,1,4.77,4.77V25.45h50.91V4.77A4.78,4.78,0,0,1,119.31,0h15.91A4.78,4.78,0,0,1,140,4.77V25.45h19.09A19.09,19.09,0,0,1,178.17,44.54ZM159.08,182.15V63.63h-140V182.15a2.39,2.39,0,0,0,2.39,2.39H156.7A2.39,2.39,0,0,0,159.08,182.15Zm-80-21.27a4.77,4.77,0,0,1-6.75,0L42.46,130.75a4.77,4.77,0,0,1,0-6.75l9-9a4.77,4.77,0,0,1,6.75,0l17.54,17.68L120,88.92a4.77,4.77,0,0,1,6.75,0l9,9a4.79,4.79,0,0,1,0,6.76Z' })
    )
  );
};

MyEventsSVG.propTypes = {
  /** a color for the icon */
  color: _propTypes2.default.string,
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string
};

MyEventsSVG.displayName = 'MyEventsSVG';

exports.default = MyEventsSVG;
MyEventsSVG.__docgenInfo = {
  'description': '# MyEventsSVG\r\nAn SVG My Events icon',
  'methods': [],
  'displayName': 'MyEventsSVG',
  'props': {
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    },
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    }
  }
};